import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useActivityLogTypes = (options = {}) => {
  const { performHttpRequests } = options || {}

  const entities = useSelector(reduxState => reduxState.entities)
  const { activityLogTypes } = entities

  useReduxAction('activityLogTypes', 'loadActivityLogTypes', {}, [performHttpRequests], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return performHttpRequests && !loaded && !loading && !errors.length
    },
  })

  return {
    activityLogTypes,
  }
}

export default useActivityLogTypes
